export const translations = {
  en: {
    // Header & Navigation
    home: 'Home',
    services: 'Services',
    projects: 'Projects',
    contact: 'Contact',
    interlock: 'Interlock',
    landscaping: 'Landscaping',
    decking: 'Decking & Railings',
    fences: 'Fences',
    
    // Home Page
    homeTitle: 'Ottawa Landscaping Company | 3 Brothers Ottawa Landscaping',
    heroTitle: 'Ottawa Landscaping Company You Can Trust',
    getQuote: 'Get a Free Quote',
    ourServices: 'Our Services',
    
    // Service Descriptions
    interlockDesc: 'Installation of pads, pathways, and patios using pavers for durable outdoor surfaces.',
    retainingWallsDesc: 'Building stone walls to manage slopes, create garden tiers, or provide structural support throughout your property.',
    landscapingDesc: 'Softscaping services including sod, artificial grass, garden beds, mulch, river rock, and professional garden hedging.',
    drivewaysDesc: 'Building interlock driveways with reinforced base preparation and custom paver borders to ensure a level, durable, and well-defined surface.',
    fencesDesc: 'Professional installation of wood and PVC privacy fences designed to define property boundaries and provide secure perimeter screening.',
    decksDesc: 'Building custom decks using natural wood or weather-resistant PVC materials to create functional lounging and dining spaces.',
    firePixtsDesc: 'Installing custom gas or propane fire pits with integrated gas lines, using either pre-made metal units or custom-built stone and interlock structures.',
    designDesc: '3D Design - Digital 3D models of your project to plan layouts, elevations, and material choices before construction starts.',
    showroomDesc: 'Visit our showroom at 920 Belfast Road to explore samples, materials, and design options for your landscape project.',
    pressureDesc: 'Deep cleaning pavers and applying fresh polymeric sand to joints to eliminate weeds and ensure proper drainage.',
    pergolaDesc: 'Design and assembly of wood or PVC pergolas to add shade and structure to your backyard or patio and maximize its space.',
    relevelDesc: 'Fixing cracked stones and re-leveling sunken interlock pads to correct pooling water and uneven surfaces.',
    
    // Service Names
    retainingWalls: 'Retaining Walls',
    driveways: 'Driveways',
    firePits: 'Fire Pits',
    design: '3D Design',
    showroom: 'Showroom',
    pressureWashing: 'Pressure Washing',
    pergolas: 'Pergolas',
    relevel: 'Relevel & Repairs',
    
    // Footer
    footerServices: 'Services',
    contactUs: 'Contact Us',
    location: 'Location',
    ottawa: 'Ottawa, ON',
    phone: 'Phone',
    email: 'Email',
    
    // Contact Page
    connectWithUs: 'Connect with Us',
    projectInMind: 'Have a project in mind ? Get in touch with our team to discuss your landscaping needs and get a free quote.',
    contactInfo: 'Contact Info',
    sendMessage: 'Send us a message',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    phoneNumber: 'Phone Number',
    yourAddress: 'Address',
    projectTimeline: 'Project Timeline',
    timelinePlaceholder: 'e.g. Within 1 month, Summer 2026',
    optional: 'optional',
    respond24: 'We respond in 24 hours',
    contactWithin24: 'We will contact you by email ({email}) or phone ({phone}) within 24 hours',
    messageSubject: 'Message Subject',
    yourMessage: 'Project Description',
    projectDescriptionPlaceholder: 'Describe your project details, scope, and goals',
    sendBtn: 'Send Message',
    sendingMessage: 'Sending message...',
    messageSent: 'Message sent — we will get back to you shortly.',
    fillRequired: 'Please fill in Name, Email, Phone, Address, Timeline and Project Description.',
    nameRequired: 'Your name is required',
    emailRequired: 'Email address is required',
    phoneRequired: 'Phone number is required',
    addressRequired: 'Address is required',
    timelineRequired: 'Project timeline is required',
    emailInvalid: 'Please enter a valid email address',
    messageRequired: 'Please describe your project',
    contactNotice: '✓ <strong>Free, no-obligation quote</strong> | Your information is secure and will never be shared',
    networkError: 'Network error. Please try again later.',
    sendingFailed: 'Sending failed. Please try again later.',
    
    // Projects Page
    projectsTitle: 'Our Projects',
    projectsPageTitle: 'Project Gallery - See Our Work | 3 Brothers Ottawa Landscaping',
    projectsMetaDescription: 'Browse our landscaping project portfolio including interlock patios, decks, fences, retaining walls, and more in the Ottawa region. View before & after photos.',
    projectsGalleryTitle: 'Our Project Gallery',
    projectPhotoViewAlt: 'project photo - view enlarged - 3 Brothers Ottawa Landscaping',

    // Interlock page
    interlockTitle: 'Interlock Paving in Ottawa',
    interlockTypesTitle: 'Types of Interlock Services',
    interlockIntro: 'We specialize in a variety of interlock paving projects:',
    interlockPatios: 'Patios',
    interlockPatiosDesc: 'Outdoor living spaces with 60mm pavers for comfort and style.',
    interlockDriveways: 'Driveways and Extensions',
    interlockDrivewaysDesc: 'Durable 80mm pavers for heavy traffic areas.',
    interlockWalkways: 'Walkways',
    interlockWalkwaysDesc: 'Connecting paths with elegant designs.',
    interlockRetainingWalls: 'Retaining Walls',
    interlockRetainingWallsDesc: 'Structural support with interlock blocks.',
    interlockSteps: 'Interlock Steps',
    interlockStepsDesc: 'Safe and attractive staircases.',
    interlockFirepits: 'Firepits',
    interlockFirepitsDesc: 'Custom-built fire pits with gas lines for outdoor enjoyment.',
    interlockPressure: 'Pressure Washing',
    interlockPressureDesc: 'Deep cleaning of pavers and application of fresh polymeric sand to joints.',
    interlockRelevels: 'Relevels and Repairs',
    interlockRelevelsDesc: 'Restore and maintain existing installations.',
    interlockCalculatorTitle: 'Try Our Interlocking Pricing Calculator!',
    interlockCalculatorIntro: 'Our pricing calculator provides a basic average cost for your interlocking project.',
    interlockCalculatorNote: 'Please note: all prices are approximate and may vary based on project specifics and stone choice.',
    sqftLabel: 'Square Footage:',
    estimatedPriceLabel: 'Estimated Price:',
    interlockPatternsTitle: 'Interlock Patterns',
    interlockGallery: 'Gallery',
    choosePatterns: 'Choose from our popular patterns:',
    patternRunningBond: 'Running Bond',
    patternBasketweave: 'Basketweave',
    patternHerringbone: 'Herringbone',
    patternRegularRandom: 'Regular Random Interlock',

    // Interlock alt + details
    patternRunningBondAlt: 'Interlock paving pattern – Running Bond',
    patternBasketweaveAlt: 'Interlock paving pattern – Basketweave',
    patternHerringboneAlt: 'Interlock paving pattern – Herringbone',
    patternRegularRandomAlt: 'Interlock paving pattern – Regular Random',
    interlockEstimateDetail: 'For a precise quote, we’ll need to visit your site, assess the area, and take measurements. Don’t worry if the estimate exceeds your budget—our expert designers can create a customized plan to fit your financial needs.',
    interlockGalleryImg1Alt: 'Beautiful interlock driveway installation in Ottawa by 3 Brothers Landscaping',
    interlockGalleryImg2Alt: 'Custom backyard interlock installation in Ottawa by 3 Brothers Landscaping',
    interlockGalleryImg3Alt: 'Backyard patio interlock project in Ottawa by 3 Brothers Landscaping',

    // Shared UI
    requestEstimate: 'Request a free estimate',
    
    // Decks Page
    decksTitle: 'Decking & Railings installation in Ottawa',
    decksHero: 'Expert deck building and railing installation for homes in Ottawa.',
    decksMaterialsTitle: 'Materials & Design Options',
    decksMaterialsDeckingLabel: 'Decking',
    decksMaterialsDeckingDesc: 'Choose from PVC, composite, or wood decks — including cedar and pressure-treated lumber — for lasting performance and timeless appeal.',
    decksMaterialsRailingsLabel: 'Railings',
    decksMaterialsRailingsDesc: 'Our railings come in metal with pickets, glass, or custom designs, adding safety and style to your deck while keeping your space open and elegant.',
    decksGallery: 'Gallery',
    decksIntro: 'Transform your outdoor space with expert deck building and railing installation in Ottawa. Whether you want a relaxing backyard retreat or a stylish entertainment area, we create decks and railings that combine durability, beauty, and low maintenance.',
    decksImgAlt1: 'Custom deck construction in Ottawa by 3 Brothers Landscaping',
    decksImgAlt2: 'Decking and metal railings installation example in Ottawa',
    decksImgAlt3: 'Professional composite deck with railings in Ottawa',

    // Landscaping Page
    landscapingTitle: 'Landscaping Services in Ottawa',
    landscapingHero: 'Beautiful gardens, lush lawns, and outdoor transformations.',
    landscapingServicesTitle: 'Our Landscaping Services',
    landscapingListIntro: 'We offer a wide range of landscaping services to enhance your property:',
    landscapingGardenBedsLabel: 'Garden Beds',
    landscapingGardenBedsDesc: 'Custom flower and vegetable garden design and installation.',
    landscapingMulchingLabel: 'Mulching',
    landscapingMulchingDesc: 'Organic and decorative mulch for weed control and moisture retention.',
    landscapingSoddingLabel: 'Sodding',
    landscapingSoddingDesc: 'Instant lawn installation with premium grass varieties.',
    landscapingTreePlantingLabel: 'Tree and Shrub Planting',
    landscapingTreePlantingDesc: 'Selection and planting of trees, shrubs, and plants.',
    landscapingIrrigationLabel: 'Irrigation Systems',
    landscapingIrrigationDesc: 'Efficient watering solutions for healthy plants.',
    landscapingGallery: 'Gallery',
    landscapingImgAlt1: 'Beautiful landscaping project in Ottawa by 3 Brothers Landscaping',
    landscapingImgAlt2: 'Custom garden bed design and installation in Ottawa',
    landscapingImgAlt3: 'Professional sod installation for lush lawns in Ottawa',

    // Fences Page
    fencesTitle: 'Fences installation in Ottawa',
    fencesHero: 'We install and repair vinyl, wood, and metal fences across Ottawa, providing durable, stylish, and low-maintenance solutions for any property.',
    fencesTypesTitle: 'Fence Types',
    fencesPVCLabel: 'PVC Fences',
    fencesPVCDesc: 'Clean, modern, and low-maintenance.',
    fencesHybridLabel: 'Hybrid Fences',
    fencesHybridDesc: 'Combine the beauty of wood or PVC with steel for privacy, sound reduction, and weather resistance.',
    fencesWoodLabel: 'Wood Fences',
    fencesWoodDesc: 'Timeless and versatile, using cedar or pressure-treated lumber for durability and natural beauty.',
    fencesIronLabel: 'Ornamental Iron Fences',
    fencesIronDesc: 'Elegant and secure, protecting your space while keeping the view open.',
    fencesChainLabel: 'Chain Link Fences',
    fencesChainDesc: 'Affordable, durable, and versatile—ideal for backyards, pools, and commercial areas.',
    fencesGlassLabel: 'Glass Fences',
    fencesGlassDesc: 'Sleek and modern, offering openness and sophistication for decks, patios, and pool areas.',

    // Projects UI
    prevLabel: 'Previous',
    nextLabel: 'Next',
    
    // Meta Tags
    metaDescription: '3 Brothers Ottawa Landscaping provides professional landscaping, interlock, decks, and fencing services in Ottawa, ON. Free estimates. Call (613) 798-3968.',
    contactPageMeta: 'Contact 3 Brothers Ottawa Landscaping for a free landscaping quote. Call (613) 798-3968 or fill out our form. We serve Ottawa, Ontario.',
    contactTitle: 'Contact Us - Get a Free Quote | 3 Brothers Ottawa Landscaping',
    projectAltSuffix: 'project example - 3 Brothers Ottawa Landscaping',
    about: 'About',
    aboutTitle: 'About 3 Brothers Ottawa Landscaping | Trusted Ottawa Landscapers',
    aboutMeta: '3 Brothers Ottawa Landscaping — family-owned landscaping, interlock, decks and fencing services in Ottawa. Learn about our team and values.',
    aboutWhyTitle: 'Why Choose 3 Brothers Ottawa Landscaping ?',
    aboutWhy: 'At 3 Brothers, we believe that a great landscape is built from the ground up. Founded by three brothers, biological and by bond, who were born and raised in the community, we combine academic discipline with 7 years of professional field experience. Our team brings a unique professional edge to the industry as a crew of entirely bilingual (English & French) students, led by a University graduate, a future Engineer, and a Business Management student. This diverse background ensures that every project benefits from technical precision, structural integrity, and clear, organized communication.',
    aboutWarrantyTitle: 'The 3-Year Warranty Guarantee',
    aboutWarranty: 'We don\'t just build it and leave. Because of our rigorous standards and in-house training for every member of our team, we are confident in the longevity of our work. We provide a 3-year warranty on our projects, giving you peace of mind that your outdoor space is built to last.',
    aboutClearStoneTitle: 'The "Clear Stone" Advantage',
    aboutClearStoneIntro: 'In Canada, the biggest enemy of a patio or driveway is the winter freeze-thaw cycle. Most companies use the "crush and run" technique because it is cheaper, but this material holds moisture, causing your stones to shift and heave when the ground freezes.',
    aboutClearStoneMethod: 'Our Method: We exclusively use 3/4" Clear Stone and 1/4" Clear High-Performance Bedding (HPB) for all of our bases.',
    aboutClearStoneWhy: 'Why it Matters: Because clear stone has no fine particles (dust/dirt), it cannot hold moisture. Water drains straight through the base and into the ground. This prevents the base from expanding in the winter, ensuring your pavers stay perfectly level and stable for years to come.',
    aboutEquipmentTitle: 'Professional Fleet & Equipment',
    aboutEquipmentBobcat: 'Bobcat MT100: This powerful compact loader allows us to move heavy materials into tight backyards without destroying your existing lawn.',
    aboutEquipmentCompaction: 'Precision Compaction: We utilize a fleet of Mikasa Plate Packers and Jumping Jacks to ensure your base is packed to professional standards.',
    aboutEquipmentHauling: 'Heavy Hauling: With our F-250 and 7-ton K-Trail Dump Trailer, we manage all material logistics and site cleanup internally.',
    aboutEquipmentTools: 'The Right Tools: We use Stihl Quick Cuts for precision stone work and Milwaukee power tools for a reliable, high-quality finish.',
    aboutPromiseTitle: 'Our Promise to You',
    aboutPromiseBilingual: '100% Bilingual Service: We are fully fluent in English and French, ensuring clear communication from the first phone call to the final walkthrough.',
    aboutPromiseEstimate: 'Free, No-Obligation Estimates: We provide detailed quotes at no cost to you. No hidden fees, no pressure.',
    aboutPromiseLocal: 'Locally Owned & Operated: We are your neighbors. We take pride in seeing our work as we drive through Ottawa.',
    aboutPromiseSatisfaction: '100% Customer Satisfaction: Our job isn\'t done until you are thrilled with your new outdoor space.',

    // CTA Section
    readyToStart: 'Ready to Transform Your Outdoor Space ?',
    freeEstimate: 'Free Estimates',
    noObligation: 'No Obligation',
    licensed: 'Licensed & Insured',
    responseTime: 'We typically respond within 24 hours',
    emailUs: 'Email Us',

    // Trust Signals
    whyChooseUs: 'Why Choose 3 Brothers Landscaping ?',
    warrantyTitle: '3 Year Warranty',
    warrantyDesc: 'Full warranty on workmanship for lasting peace of mind',
    experienceTitle: 'Over 99+ Projects Completed',
    experienceDesc: 'Trusted by hundreds of local homeowners and businesses',
    guaranteeTitle: '100% Satisfaction Guaranteed',
    guaranteeDesc: 'If you\'re not satisfied, we\'ll make it right',
    onTimeTitle: 'On-Time Completion',
    onTimeDesc: 'We respect your time and deliver projects on schedule',
    ratedTitle: '5/5 Star Rated',
    ratedDesc: 'Consistently excellent reviews from satisfied customers',
    licensedTitle: 'Licensed & Insured',
    licensedDesc: 'Fully licensed and insured for your protection',

    // FAQ Section
    frequentlyAsked: 'Frequently Asked Questions',
    stillHaveQuestions: 'Still have questions ?',
    faqCostTitle: 'How much do your services cost ?',
    faqCostAnswer: 'Pricing varies based on project scope, size, and materials. You can find an estimate for interlock projects under our interlock page in our services section. We also free estimates after assessing your specific needs. Contact us for a personalized quote.',
    faqTimelineTitle: 'How long does a project take ?',
    faqTimelineAnswer: 'Project duration depends on complexity and scope. Most residential projects take 1-3 weeks. We\'ll provide a detailed timeline during your consultation.',
    faqWarrantyTitle: 'Do you offer warranties ?',
    faqWarrantyAnswer: 'Yes! We stand behind all our work with comprehensive 3 year warranties on workmanship. Ask us about specific warranty details for your project.',
    faqDesignTitle: 'Can you help with design ?',
    faqDesignAnswer: 'Absolutely! We offer 3D design services to help visualize your project before we begin. Our team can also provide recommendations based on your budget and preferences.',
    faqSeasonTitle: 'What\'s the best season for landscaping ?',
    faqSeasonAnswer: 'Spring, summer, and fall are ideal for most landscaping projects due to favorable weather conditions. However, we work from April through October according to weather condition. Contact us to discuss the best timing for your specific project.',
    faqMaintenanceTitle: 'What maintenance is required ?',
    faqMaintenanceAnswer: 'Maintenance requirements vary by service. Patios need occasional cleaning, gardens need seasonal care, and decks may need sealing. We provide detailed care instructions for all projects.',
    faqPaymentTitle: 'What payment methods do you accept ?',
    faqPaymentAnswer: 'We accept cash, check, and e-transfer. Other payment methods may be available upon request but will incure additional fees.',
    faqInsuranceTitle: 'Are you licensed and insured ?',
    faqInsuranceAnswer: 'Yes, we are fully licensed and insured. Your property and investment are protected throughout the entire project.',

    reviewsTitle: "What Our Clients Say",
    readMoreReviews: "Read more on Google",
    reviews: [
      {
        name: "Julie G",
        text: "We highly recommend these amazing young people. Energetic, fast, efficient and punctual, they communicate very well, validating the final expected result. We are very happy with their meticulous work. Very professional team that we will hire again!",
        stars: 5
      },
      {
        name: "Laeticia P",
        text: "We had a great experience with these guys! They were extremely efficient, and delivered the desired product. They tore down our old deck, which was molding, and built a sturdy one. They were accommodating to every request, and were great at communication. They will be our first choice for future projects.",
        stars: 5
      },
      {
        name: "Olivier Lafontaine",
        text: "Fantastic team. On time, efficient, and very detail-oriented.",
        stars: 5
      }
    ]
  },
  
  fr: {
    // Header & Navigation
    home: 'Accueil',
    services: 'Services',
    projects: 'Projets',
    contact: 'Contact',
    interlock: 'Pavage',
    landscaping: 'Aménagement paysager',
    decking: 'Terrasses, garde-corps et rampes',
    fences: 'Clôtures',
   
    // Home Page
    homeTitle: '3 Brothers Ottawa Landscaping | Entreprise de paysagisme à Ottawa',
    heroTitle: 'Entreprise de paysagisme de la région d\'Ottawa en qui vous pouvez faire confiance',
    getQuote: 'Obtenir un devis gratuit',
    ourServices: 'Nos services',
   
    // Service Descriptions
    interlockDesc: 'Installation de dalles, allées piétonnes et patios à l\'aide de pavés pour des surfaces extérieures de longue durée.',
    retainingWallsDesc: 'Construction de murs en pierre permettant de gérer les inclinaisons, de créer différents niveaux de jardin ou de munir l\'ensemble de votre propriété d\'une structure de soutien.',
    landscapingDesc: 'Services d\'aménagement paysager incluant la pelouse, l\'herbe artificielle, les plates-bandes, le paillis, les cailloux et les haies de jardin de niveau professionnel.',
    drivewaysDesc: 'Construction d\'allées en pavés unis qui comprend le renforcement de la base et l\'installation de bordures en pavés adaptées aux besoins de votre propriété pour ainsi assurer une surface plane, durable et bien délimitée.',
    fencesDesc: 'Installation professionnelle de clôtures en bois ou en PVC conçues pour assurer votre intimité, définir les limites de votre propriété et sécuriser son périmètre.',
    decksDesc: 'Construction de terrasses personnalisées à l\'aide de bois naturel ou de matériaux PVC résistants aux intempéries pour créer des aires de détente et des espaces repas fonctionnels.',
    firePixtsDesc: 'Installation sur mesure de foyers au gaz ou au propane comprenant des canalisations d\'alimentation incorporées de façon discrète et harmonieuse à l\'aide d\'unités métalliques préfabriquées ou de structures en pierre ou en pavés unis.',
    designDesc: 'Modèles 3D numériques personnalisés permettant de bien visualiser votre projet avant le début des travaux et ainsi bien planifier les dispositions, les écarts au niveau de l\'élévation et le choix des matériaux.',
    showroomDesc: 'Visitez notre salle d\'exposition à 920 Belfast Road pour découvrir des échantillons, des matériaux et des options de conception pour votre projet paysager.',
    pressureDesc: 'Nettoyage en profondeur des pavés et application de nouveau sable polymère aux interstices afin d\'éliminer les herbes indésirables et d\'assurer un drainage optimal.',
    pergolaDesc: 'Conception et assemblage de pergolas en bois ou PVC pour créer des zones d\'ombre, structurer et optimiser l\'espace de votre cour arrière ou patio.',
    relevelDesc: 'Réparation des pierres fissurées et nivelage des pavés unis enfoncés pour corriger les surfaces inégales et prévenir l\'accumulation d\'eau.',
   
    // Service Names
    retainingWalls: 'Murs de soutènement',
    driveways: 'Allées',
    firePits: 'Foyers',
    design: 'Conception 3D',
    showroom: 'Salle d’exposition',
    pressureWashing: 'Nettoyage haute pression',
    pergolas: 'Pergolas',
    relevel: 'Nivelage et réparations',
   
    // Footer
    footerServices: 'Services',
    contactUs: 'Nous contacter',
    location: 'Localisation',
    ottawa: 'Ottawa, ON',
    phone: 'Téléphone',
    email: 'Courriel',
   
    // Contact Page
    connectWithUs: 'Communiquez avec nous',
    projectInMind: 'Avez-vous un projet en tête ? Communiquez avec notre équipe pour discuter de vos besoins en matière de paysagisme et obtenez un devis gratuit.',
    contactInfo: 'Informations de contact',
    sendMessage: 'Envoyez-nous un message',
    yourName: 'Votre nom',
    yourEmail: 'Votre courriel',
    phoneNumber: 'Numéro de téléphone',
    yourAddress: 'Adresse',
    projectTimeline: 'Délais du projet',
    timelinePlaceholder: 'ex : d\'ici 1 mois, été 2026',
    optional: 'facultatif',
    respond24: 'Nous répondons dans les 24 heures',
    contactWithin24: 'Nous vous contacterons par courriel ({email}) ou par téléphone ({phone}) dans les 24 heures',
    messageSubject: 'Sujet du message',
    yourMessage: 'Description du projet',
    projectDescriptionPlaceholder: 'Décrivez les détails, la portée et les objectifs du projet',
    sendBtn: 'Envoyer le message',
    sendingMessage: 'Envoi du message...',
    messageSent: 'Message envoyé — nous vous contacterons sous peu.',
    fillRequired: 'Veuillez remplir Nom, Courriel, Téléphone, Adresse, Délais et Description du projet.',
    nameRequired: 'Votre nom est requis',
    emailRequired: 'L\'adresse courriel est requise',
    phoneRequired: 'Le numéro de téléphone est requis',
    addressRequired: 'L\'adresse est requise',
    timelineRequired: 'Le délai du projet est requis',
    emailInvalid: 'Veuillez entrer une adresse courriel valide',
    messageRequired: 'Veuillez décrire votre projet',
    contactNotice: '✓ <strong>Devis gratuits et sans obligation / Vos informations demeurent sécurisées et ne seront jamais partagées.',
    networkError: 'Erreur réseau. Veuillez réessayer plus tard.',
    sendingFailed: 'L\'envoi a échoué. Veuillez réessayer plus tard.',
   
    // Projects Page
    projectsTitle: 'Nos projets',
    projectsPageTitle: 'Éventail de projets | Nos travaux | 3 Brothers Ottawa Landscaping',
    projectsMetaDescription: 'Consultez notre éventail de projets de paysagisme comprenant des patios en pavés unis, terrasses, clôtures, murs de soutènement, et bien plus. Le tout dans la région d\'Ottawa. Examinez les photos avant et après.',
    projectsGalleryTitle: 'Notre éventail de projets',
    projectPhotoViewAlt: 'Photo du projet - vue agrandie - 3 Brothers Ottawa Landscaping',


    // Interlock page
    interlockTitle: 'Pavage intercalé dans la région d\'Ottawa',
    interlockTypesTitle: 'Services offerts en matière de pavage',
    interlockIntro: 'Nous sommes spécialisés dans une variété de projets de pavage :',
    interlockPatios: 'Patios ',
    interlockPatiosDesc: 'Espaces de vie extérieurs avec des dalles de 60 mm pour le confort et le style.',
    interlockDriveways: 'Allées et extensions ',
    interlockDrivewaysDesc: 'Dalles de 80 mm de longue durée pour les zones très fréquentées.',
    interlockWalkways: 'Allées piétonnes ',
    interlockWalkwaysDesc: 'Allées de liaison aux designs élégants.',
    interlockRetainingWalls: 'Murs de soutènement ',
    interlockRetainingWallsDesc: 'Support structurel avec blocs emboîtbles.',
    interlockSteps: 'Marches en pavé ',
    interlockStepsDesc: 'Escaliers sécuritaires et élégants.',
    interlockFirepits: 'Foyers extérieurs ',
    interlockFirepitsDesc: 'Foyers extérieurs avec conduites de gaz, construits sur mesure pour profiter de votre espace en plein air.',
    interlockPressure: 'Nettoyage haute pression ',
    interlockPressureDesc: 'Nettoyage en profondeur des pavés et application de nouveau sable polymère aux interstices.',
    interlockRelevels: 'Remise à niveau et réparations ',
    interlockRelevelsDesc: 'Restaurer et entretenir les installations existantes.',
    interlockCalculatorTitle: 'Essayez notre calculateur de coûts pour pavés !',
    interlockCalculatorIntro: 'Notre calculateur fournit un coût moyen approximatif pour votre projet de pavage.',
    interlockCalculatorNote: 'Veuillez noter : tous les montants sont approximatifs et peuvent varier en fonction des spécificités de votre projet et du choix de pierre.',
    sqftLabel: 'Pieds carrés :',
    estimatedPriceLabel: 'Prix estimé :',
    interlockPatternsTitle: 'Motifs de pavé',
    interlockGallery: 'Galerie',
    choosePatterns: 'Choisissez parmi nos motifs populaires :',
    patternRunningBond: 'Rang décalé (Running Bond)',
    patternBasketweave: 'Tressage (Basketweave)',
    patternHerringbone: 'Chevron (Herringbone)',
    patternRegularRandom: 'Pavage aléatoire régulier',


    // Interlock alt + details (FR)
    patternRunningBondAlt: 'Motif de pavage interlock rang décalé',
    patternBasketweaveAlt: 'Motif de pavage interlock tressage',
    patternHerringboneAlt: 'Motif de pavage interlock chevron',
    patternRegularRandomAlt: 'Motif de pavage interlock aléatoire régulier',
    interlockEstimateDetail: 'Pour un devis précis, nous devrons visiter le site où vous souhaitez les travaux, évaluer la zone et prendre des mesures. Ne vous inquiétez pas si l\'estimation dépasse votre budget — nos concepteurs experts peuvent créer un plan personnalisé adapté à vos besoins financiers.',
    interlockGalleryImg1Alt: 'Belle allée en pavé interlock installée à Ottawa par 3 Brothers Landscaping',
    interlockGalleryImg2Alt: 'Installation sur mesure de pavé interlock dans une cour arrière à Ottawa par 3 Brothers Landscaping',
    interlockGalleryImg3Alt: 'Projet de patio arrière en pavé interlock à Ottawa par 3 Brothers Landscaping',


    // Shared UI
    requestEstimate: 'Demandez un devis gratuit',
   
    // Decks Page
    decksTitle: 'Terrasses, garde-corps et rampes dans la région d\'Ottawa',
    decksHero: 'Construction experte de terrasses et installation de garde-corps et rampes pour les résidences de la région d\'Ottawa.',
    decksMaterialsTitle: 'Matériaux et options de conception',
    decksMaterialsDeckingLabel: 'Terrasses ',
    decksMaterialsDeckingDesc: 'Choisissez parmi PVC, composite ou bois y compris cèdre et bois traité sous pression pour une tenue à long terme et un style intemporel.',
    decksMaterialsRailingsLabel: 'Garde-corps et rampes ',
    decksMaterialsRailingsDesc: 'Nos garde-corps et rampes sont construits sur mesure, en métal avec barreaux ou en verre. Ils ajoutent sécurité et élégance à votre terrasse tout en conservant l\'espace ouvert et raffiné.',
    decksGallery: 'Galerie',
    decksIntro: 'Transformez votre espace extérieur par la construction d’une terrasse et l\'installation de garde-corps et rampes à l’aide d’experts de la région d\'Ottawa. Que vous souhaitiez un coin détente ou un espace de réception élégant, nous créons des terrasses durables et de bon goût.',
    decksImgAlt1: 'Construction de terrasse sur mesure dans la région d\'Ottawa par 3 Brothers Ottawa Landscaping',
    decksImgAlt2: 'Exemple d\'installation de terrasse et garde-corps métalliques dans la région d\'Ottawa',
    decksImgAlt3: 'Terrasse professionnelle en composite avec garde-corps dans la région d\'Ottawa',


    // Landscaping Page
    landscapingTitle: 'Aménagement paysager dans la région d\'Ottawa',
    landscapingHero: 'Jardins splendides, pelouses luxuriantes et transformations extérieures.',
    landscapingServicesTitle: 'Nos services d\'aménagement paysager',
    landscapingListIntro: 'Nous proposons une vaste gamme de services d\'aménagement pour améliorer votre propriété :',
    landscapingGardenBedsLabel: 'Plates-bandes ',
    landscapingGardenBedsDesc: 'Conception et installation personnalisées de plates-bandes.',
    landscapingMulchingLabel: 'Paillage ',
    landscapingMulchingDesc: 'Paillis organique et décoratif pour le contrôle des mauvaises herbes et la rétention d\'humidité.',
    landscapingSoddingLabel: 'Pose de gazon ',
    landscapingSoddingDesc: 'Installation rapide de pelouse avec des variétés de semences haut de gamme.',
    landscapingTreePlantingLabel: 'Plantation d\'arbres et d\'arbustes ',
    landscapingTreePlantingDesc: 'Plantation d\'arbres, d\'arbustes et de plantes à partir d’une sélection personnalisée pour vous.', 
    landscapingIrrigationLabel: 'Systèmes d\'irrigation ',
    landscapingIrrigationDesc: 'Solutions d\'arrosage efficaces pour des plantes saines.',
    landscapingGallery: 'Galerie',
    landscapingImgAlt1: 'Superbe projet d\'aménagement paysager dans la région d\'Ottawa par 3 Brothers Ottawa Landscaping',
    landscapingImgAlt2: 'Conception sur mesure et aménagement de plates-bandes dans la région d\'Ottawa',
    landscapingImgAlt3: 'Pose professionnelle de gazon pour des pelouses luxuriantes dans la région d\'Ottawa',


    // Fences Page
    fencesTitle: 'Installation de clôtures dans la région d\'Ottawa',
    fencesHero: 'Nous installons et réparons des clôtures en vinyle, bois et métal dans la région d\'Ottawa, en offrant des solutions de longue durée, qui demandent peu d\'entretien et qui ont du style.',
    fencesTypesTitle: 'Types de clôtures',
    fencesPVCLabel: 'Clôtures PVC ',
    fencesPVCDesc: 'Propres, modernes et facile d\'entretien.',
    fencesHybridLabel: 'Clôtures hybrides ',
    fencesHybridDesc: 'Combine la beauté du bois ou du PVC avec l\'acier afin de préserver l\'intimité, atténuer le bruit et résister aux intempéries.',
    fencesWoodLabel: 'Clôtures en bois ',
    fencesWoodDesc: 'Classiques et polyvalentes, en cèdre ou en bois traité, pour un charme naturel de longue durée.',
    fencesIronLabel: 'Clôtures en fer forgé ',
    fencesIronDesc: 'Élégantes et sécuritaires, elles protègent votre espace tout en préservant la vue.',
    fencesChainLabel: 'Clôtures en grillage métallique ',
    fencesChainDesc: 'Abordables, durables et polyvalentes. Idéales pour les cours arrières, les piscines et les endroits commerciaux',
    fencesGlassLabel: 'Clôtures en verre ',
    fencesGlassDesc: 'Modernes, élégantes et sophistiquées, elles laissent une impression d\'ouverture aux terrasses, patios et piscines.',


    // Projects UI
    prevLabel: 'Précédent',
    nextLabel: 'Suivant',
   
    // Meta Tags
    metaDescription: '3 Brothers Ottawa Landscaping offre des services professionnels de paysagisme, pavage, construction de terrasses et de clôtures dans la région d\'Ottawa, ON. Devis gratuits. Téléphonez le (613) 798-3968.',
    contactPageMeta: 'Communiquez avec 3 Brothers Ottawa Landscaping pour un devis gratuit de paysagisme. Téléphonez le (613) 798-3968 ou remplissez notre formulaire. Nous desservons Ottawa, Ontario.',
    contactTitle: 'Contactez-nous - Devis gratuit | 3 Brothers Ottawa Landscaping',
    projectAltSuffix: 'Exemple de projet - 3 Brothers Ottawa Landscaping',
    about: 'À propos',
    aboutTitle: 'À propos de 3 Brothers Ottawa Landscaping | Paysagistes de confiance dans la région d’Ottawa',
    aboutMeta: '3 Brothers Ottawa Landscaping — entreprise familiale offrant services de paysagisme, pavage, construction de terrasses et clôtures dans la région d\'Ottawa. Apprenez-en plus sur notre équipe et nos valeurs.',
    aboutWhyTitle: 'Pourquoi choisir 3 Brothers Ottawa Landscaping ?',
    aboutWhy: 'Chez 3 Brothers, nous croyons qu\'un bon aménagement paysager commence par une base solide. Nous sommes trois frères, de sang et de cœur, qui sommes nés et avons grandi dans la communauté et qui avons fondé 3 Brothers. Nous combinons discipline académique et 7 ans d\'expérience professionnelle sur le terrain. En tant qu’étudiants entièrement bilingues (anglais & français), dirigée par un diplômé universitaire, un futur ingénieur et un étudiant en gestion d\'entreprise, notre équipe apporte une valeur ajoutée unique à l\'industrie. Nos parcours diversifiés garantissent à chaque projet une précision technique, une intégrité structurelle et une communication claire et organisée.',
    aboutWarrantyTitle: 'La garantie de 3 ans',
    aboutWarranty: 'Nous ne faisons pas que construire et s’enfuir. Grâce à nos normes rigoureuses et à la formation personnalisée de chaque membre de notre équipe, nous avons confiance en la longévité de notre travail. Nous offrons une garantie de 3 ans sur nos projets, vous donnant ainsi la tranquillité d\'esprit d\'un espace extérieur conçu pour durer.',
    aboutClearStoneTitle: 'L\'avantage du "Clear Stone"',
    aboutClearStoneIntro: 'Au Canada, le plus grand ennemi d\'un patio ou d\'une allée est le cycle du gel et du dégel associé à l\'hiver. La plupart des entreprises utilisent la technique du gravier concassé et compacté “crush and run” car elle est moins dispendieuse. Cependant, ce matériau retient l\'humidité et provoque le déplacement et le soulèvement des pavés lorsque le sol gèle.',
    aboutClearStoneMethod: 'Notre méthode : Nous utilisons exclusivement du gravier clair 3/4" et un lit de pose haute performance 1/4" (HPB) pour toutes nos bases.',
    aboutClearStoneWhy: 'Son importance : Le gravier clair ne contient pas de particules fines (poussière), il ne retient donc pas l\'humidité. L\'eau s\'écoule directement à travers la base et ensuite dans le sol, empêchant l\'expansion hivernale et permettant à vos pavés de demeurer parfaitement stables et bien nivelés pendant des années.',
    aboutEquipmentTitle: 'Flotte et équipement professionnel',
    aboutEquipmentBobcat: 'Bobcat MT100 : Ce chargeur compact puissant nous permet de déplacer des matériaux lourds dans des arrière-cours étroites sans endommager la pelouse existante.',
    aboutEquipmentCompaction: 'Compactage de précision : Nous utilisons un parc de compacteurs à plaques Mikasa et des pilonneuses pour garantir une base compacte selon les normes professionnelles.',
    aboutEquipmentHauling: 'Transport lourd : Notre F-250 et notre remorque basculante K-Trail de 7 tonnes nous permettent de bien gérer les matériaux et assurer le nettoyage complet du chantier.',
    aboutEquipmentTools: 'Outils appropriés : Nous utilisons des scies Stihl Quick Cut pour la précision et des outils électriques Milwaukee pour une finition fiable et de qualité.',
    aboutPromiseTitle: 'Notre promesse',
    aboutPromiseBilingual: 'Service 100% bilingue : Nous maîtrisons parfaitement l\'anglais et le français, assurant une communication claire dès le premier appel jusqu\'à la visite finale.',
    aboutPromiseEstimate: 'Devis gratuits et sans obligation : Nous offrons des estimations détaillées et sans frais. Aucune pression, aucun frais caché.',
    aboutPromiseLocal: 'Entreprise locale : Nous sommes vos voisins. Nous sommes fiers de voir notre travail dans la région d\'Ottawa.',
    aboutPromiseSatisfaction: 'Votre satisfaction à 100% nous tient à coeur : Notre travail ne se termine qu’au moment où vous êtes enchanté de votre nouvel espace extérieur.',
    
    //French text bellow not reviwed

    // Section CTA
    readyToStart: 'Prêt à transformer votre espace extérieur ?',
    freeEstimate: 'Devis gratuits',
    noObligation: 'Sans obligation',
    licensed: 'Autorisé et assuré',
    responseTime: 'Nous répondons généralement dans les 24 heures',
    emailUs: 'Envoyez-nous un message',

    // Signaux de confiance
    whyChooseUs: 'Pourquoi choisir 3 Brothers Landscaping ?',
    warrantyTitle: 'Garantie de 3 ans',
    warrantyDesc: 'Garantie complète sur la main-d’œuvre pour votre tranquillité d’esprit',
    experienceTitle: 'Plus de 99 projets complétés',
    experienceDesc: 'Approuvé par des centaines de propriétaires et d’entreprises locales',
    guaranteeTitle: '100 % de satisfaction garantie',
    guaranteeDesc: 'Si vous n’êtes pas satisfait, nous rectifierons le tir',
    onTimeTitle: 'Livraison à temps',
    onTimeDesc: 'Nous respectons votre temps et livrons les projets selon le calendrier',
    ratedTitle: '5/5 étoiles',
    ratedDesc: 'Des avis constamment excellents de clients satisfaits',
    licensedTitle: 'Autorisé et assuré',
    licensedDesc: 'Pleinement autorisé et assuré pour votre protection',

    // Section FAQ
    frequentlyAsked: 'Questions fréquemment posées',
    stillHaveQuestions: 'Vous avez encore des questions ?',
    faqCostTitle: 'Combien coûtent vos services ?',
    faqCostAnswer: 'Les prix varient selon la portée du projet, la taille et les matériaux. Vous pouvez trouver une estimation pour les projets de pavage sur notre page de pavage dans la section services. Nous proposons également des devis gratuits après avoir évalué vos besoins spécifiques. Contactez-nous pour un devis personnalisé.',
    faqTimelineTitle: 'Combien de temps dure un projet ?',
    faqTimelineAnswer: 'La durée du projet dépend de la complexité et de l\'ampleur. La plupart des projets résidentiels prennent de une à 3 semaines. Nous vous fournirons un calendrier détaillé lors de votre consultation.',
    faqWarrantyTitle: 'Offrez-vous des garanties ?',
    faqWarrantyAnswer: 'Oui ! Nous protégeons tous nos travaux avec des garanties complètes sur les matériaux et la main-d\'œuvre. Demandez-nous les détails de la garantie spécifique à votre projet.',
    faqDesignTitle: 'Pouvez-vous nous aider avec la conception ?',
    faqDesignAnswer: 'Absolument ! Nous offrons des services de conception 3D pour vous aider à visualiser votre projet avant de commencer. Notre équipe peut vous fournir des recommandations en fonction de votre budget et de vos préférences.',
    faqSeasonTitle: 'Quelle est la meilleure saison pour l\'aménagement paysager ?',
    faqSeasonAnswer: 'Le printemps, l\'été et l\'automne sont idéaux pour la plupart des projets d\'aménagement paysager en raison des conditions météorologiques favorables. Cependant, nous travaillons d\'avril à octobre selon les conditions. Contactez-nous pour discuter du meilleur moment pour votre projet spécifique.',
    faqMaintenanceTitle: 'Quel entretien est nécessaire ?',
    faqMaintenanceAnswer: 'Les exigences en matière d\'entretien varient selon le service. Les patios requièrent un nettoyage occasionnel, les jardins méritent un entretien saisonnier et les terrasses peuvent nécessiter un scellage. Nous fournirons des instructions d\'entretien détaillées pour tous les projets.',
    faqPaymentTitle: 'Quelles méthodes de paiement acceptez-vous ?',
    faqPaymentAnswer: 'Nous acceptons l\'argent comptant, les chèques et les virements e-Transfer. D\'autres méthodes de paiement peuvent être disponibles sur demande, mais elles peuvent entraîner des frais supplémentaires.',
    faqInsuranceTitle: 'Êtes-vous autorisé et assuré ?',
    faqInsuranceAnswer: 'Oui, nous sommes pleinement autorisés et assurés. Votre propriété et votre investissement sont protégés tout au long du projet.',
  
    reviewsTitle: "Ce que disent nos clients",
      readMoreReviews: "Lire plus sur Google",
      reviews: [
        {
          name: "Julie G",
          text: "Nous recommandons fortement ces jeunes gens incroyables. Énergiques, rapides, efficaces et ponctuels, ils communiquent très bien, validant le résultat final attendu. Nous sommes très heureux de leur travail méticuleux. Une équipe très professionnelle que nous réembaucherons!",
          stars: 5
        },
        {
          name: "Laetitia P",
          text: "Nous avons eu une excellente expérience avec ces gars! Ils ont été extrêmement efficaces et ont livré le produit désiré. Ils ont démoli notre ancienne terrasse qui moisissait et en ont construit une solide. Ils ont été accommodants pour chaque demande et excellents en communication. Ils seront notre premier choix pour nos futurs projets.",
          stars: 5
        },
        {
          name: "Olivier Lafontaine",
          text: "Équipe fantastique. À l'heure, efficace et avec un grand souci du détail.",
          stars: 5
        }
      ]
  }
};

export const useTranslation = (language) => (key) => {
  return translations[language]?.[key] || key;
};
